export default "__VITE_ASSET__4d6d2ffa__"